/**
 * Lavelle Faceted Filtering & Sorting (Collections & Search)
 */

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = this.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const filterForm = this.querySelector('form');
    if (filterForm) {
      filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
    
    // Sort dropdown change
    const sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', this.onSortChange.bind(this));
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onSortChange(e) {
    const value = e.target.value;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    this.renderPage(url.toString());
  }

  onSubmitHandler(e) {
    const form = this.querySelector('form');
    if (!form) return;
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;
    this.renderPage(url);
  }

  onActiveFilterClick(e) {
    e.preventDefault();
    const url = e.currentTarget.href;
    this.renderPage(url);
  }

  async renderPage(url) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      productGridContainer.style.opacity = '0.5';
      productGridContainer.style.pointerEvents = 'none';
    }

    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newProductGrid = html.getElementById('ProductGridContainer');
      const newFacets = html.querySelector('facet-filters-form');

      if (productGridContainer && newProductGrid) {
        productGridContainer.innerHTML = newProductGrid.innerHTML;
        productGridContainer.style.opacity = '1';
        productGridContainer.style.pointerEvents = '';
      }

      if (newFacets) {
        this.innerHTML = newFacets.innerHTML;
      }

      window.history.pushState({ path: url }, '', url);

      // Re-trigger wishlist state sync for new elements
      if (window.LavelleWishlist) {
        window.LavelleWishlist.syncButtons();
      }
    } catch (err) {
      console.error('Error filtering:', err);
      if (productGridContainer) {
        productGridContainer.style.opacity = '1';
        productGridContainer.style.pointerEvents = '';
      }
    }
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);
